import { Context } from "@nuxt/types/app";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function (context: Context) {
  function isJSONParsable(value: string): boolean {
    try {
      JSON.parse(value);
    } catch (e) {
      return false;
    }
    return true;
  }

  return {
    isJSONParsable,
  };
}
